export const DEFAULT_LOOKUP_KEY = "basic_monthly";

export function getLookupKeyFromUrl(): string {
  const params = new URLSearchParams(window.location.search);
  // Prefer user-friendly URL param `plan`, fallback to legacy `lookup_key`.
  const lookupKey = params.get("plan") || params.get("lookup_key");

  // Return the lookup key from URL if present, otherwise return default
  // Backend will validate and handle invalid lookup keys
  return lookupKey || DEFAULT_LOOKUP_KEY;
}
